export default "__VITE_ASSET__D1s_iENK__"